var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#F4F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6511 44C33.2831 44 32.9311 43.848 32.6791 43.58L26.1951 36.6747C25.6898 36.1387 25.7178 35.2947 26.2538 34.7907C26.7911 34.2867 27.6351 34.3133 28.1378 34.8493L33.6378 40.704L44.8484 28.4347C45.3471 27.8893 46.1898 27.8533 46.7338 28.3493C47.2764 28.8453 47.3138 29.6893 46.8178 30.232L34.6351 43.5653C34.3858 43.84 34.0311 43.9973 33.6604 44H33.6511Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/IconSuccess.96cae07fa96d715c33fdcf4556324d50.svg";
export { ForwardRef as ReactComponent };